import React from 'react';
import ApprovalV2BoardContainer from '../../containers/approval/ApprovalV2BoardContainer';

const ApprovalV2BoardPage = () => {
  return <ApprovalV2BoardContainer />;
};

export default ApprovalV2BoardPage;
